import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';

import axios from 'src/app/Service/axios';

import { NotificationService } from './notification.service';

import { OtherService } from './other.service';

import { GurdServiceService } from './gurd-service.service';

declare let $: any;

@Injectable({

  providedIn: 'root',

})

export class DataService {

  carData: any;

  carData_New: any;

  carObserver: BehaviorSubject<any> = new BehaviorSubject(null);

  carObserver_New: BehaviorSubject<any> = new BehaviorSubject(null);

  oservableCar: any;

  observableCar_New: any;

  stopData: any;

  carList: any;

  carList_New: any;

  enterExitdata: any;

  gpsIoData: any;

  dashbordData: any;

  dashbordTaxiData: any;

  dashbordAddData: any;

  carListTxtSearch: any = "";

  constructor(private otherService: OtherService, private router: Router, private notifyService: NotificationService, private gurdService: GurdServiceService) {

    this.oservableCar = this.carObserver.asObservable();

    this.observableCar_New = this.carObserver_New.asObservable();

  }

  getData = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      bOnlyHasGPS: true,

      bFromWeb: true,

      bWithIcon: true,

    };

    this.otherService.Showspinner();

    // const resp_2 = await axios.post(`FleetYar_Car_List`, model);

    const resp = await axios.post(`Radyab_GetAllCar`, model);

    this.otherService.nonespinner();

    this.carData = resp.data;

    // console.log(this.carData[0])

    // console.log(JSON.parse(resp_2.data.toString())[0])

    this.carObserver.next(this.carData);

  };

  getData_New = async () => {

    const cached = localStorage.getItem('carData_New');

    if (cached) {

      this.carData_New = JSON.parse(this.gurdService.decrypt(cached));

      this.carObserver_New.next(this.carData_New);

      return;

    }

    else {

      var model = {

        ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        bOnlyHasGPS: true,

        bWithIcon: true,

      };

      this.otherService.Showspinner();

      const resp = await axios.post(`FleetYar_Car_List_New`, model);

      this.otherService.nonespinner();

      let res = resp.data;

      if (res?.ISSessionExpired == true || res[0]?.ISSessionExpired == true) {

        this.otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: '127' } });

        return this.notifyService.showError('نشست شما منقضی شده است!');

      }

      else {

        this.carData_New = res;

        this.carObserver_New.next(this.carData_New);

      }

    }

  }

  getCarList = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      bFromWeb: true

    };

    this.otherService.Showspinner();

    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

    const resp = await axios.post(`Radyab_GetAllCar?strSession=${session}`, model);

    this.otherService.nonespinner();

    if (resp.data[0].ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      // this.router.navigate(['/']);
      this.router.navigate(['login'], { queryParams: { error: '128' } });


      return;
    }

    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }

    else {

      this.carList = resp.data;

    }

  }

  getCarList_New = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      bOnlyHasGPS: false,

      bWithIcon: false,

    };

    this.otherService.Showspinner();

    // const resp = await axios.post(`FleetYar_Car_List`, model);

    const resp = await axios.post(`FleetYar_Car_List_New `, model);

    let res = resp.data;

    this.otherService.nonespinner();

    if (res.ISSessionExpired == true || res[0].ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['/']);

      this.router.navigate(['login'], { queryParams: { error: '129' } });

      this.notifyService.showError('اطلاعات کاربری خود را مجددا وارد کنید')

      return;

    }

    if (res == null) return this.notifyService.showError('بروز خطا در سامانه');

    else {

      this.carList_New = resp.data;

    }

  }

  getStop = async (id: any) => {
    this.otherService.Showspinner();
    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
    const resp = await axios.post(
      `ReportParkDetailByTime?vstrSDate=${this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!)}&vstrUnitID=${id}&vstrEDate=${this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!)}&strSTime=${this.gurdService.decrypt(window.localStorage.getItem('reportStime')!)}&strETime=${this.gurdService.decrypt(window.localStorage.getItem('reportEtime')!)}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`
    );
    this.otherService.nonespinner();
    this.stopData = resp.data;
  }

  getEnterAndExit = async (model: any) => {
    this.otherService.Showspinner();
    const resp = await axios.post("Report_InOutBasePreDifineGeoFance", model);
    this.otherService.nonespinner();
    this.enterExitdata = JSON.parse(resp.data);
    if (this.enterExitdata.length == 0) {
      this.notifyService.showInfo("دیتایی یافت نشد", "");
    }
  }

  getGpsIo = async (model: any) => {
    this.otherService.Showspinner();
    const resp = await axios.post("Report_GPSIO", model);
    this.gpsIoData = JSON.parse(resp.data)
    this.otherService.nonespinner();

  }

}
